import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsViewsByLinkQuery } from "../graphql/queries";
import type {
  AnalyticsViewsByLinkQueryType,
  AnalyticsViewsByLinkQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsViewsByLinkQuery = (
  options?: QueryHookOptions<
    AnalyticsViewsByLinkQueryType,
    AnalyticsViewsByLinkQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsViewsByLinkQueryType,
    AnalyticsViewsByLinkQueryVariablesType
  >(AnalyticsViewsByLinkQuery, options);
};
